import config from '../config/app';
import barba from '@barba/core';
import gsap from 'gsap';

export default {
    // beforeCreate(args) {
    //     console.log('[common] -> beforeCreate', args);
    // },
    // beforeDestroy(args) {
    //     console.log('[common] -> beforeDestroy', args);
    // },
    // beforeMount(args) {
    //     console.log('[common] -> beforeMount', args);
    // },
    // created(args) {
    //     console.log('[common] -> created', args);
    // },
    // destroyed(args) {
    //     console.log('[common] -> destroyed', args);
    // },
    mounted(args) {
        // console.log('[common] -> mounted', args, config.all());

        barba.init({
            transitions: [{
                name: 'opacity-transition',
                leave(data) {
                    return gsap.to(data.current.container, {
                        duration: 0.3,
                        opacity: 0
                    });
                },
                enter(data) {
                    return gsap.set(data.next.container, {
                        opacity: 1
                    });
                }
            }]
        });
    },
};
